import { useContext, useEffect, useState } from "react";
import getGreeting from "../../Utilities/getGreeting";
import ServicesSlider from "../ServiceSlider/serviceSlider";
import { UserContext } from "../../Context/UserContext";
import axios from "axios";
import { Carousel } from "react-bootstrap";
import { AboutUsSection } from "../AboutUs/aboutUs";
import FeatureCards from "../FeatureCards/FeatureCards";
import ReserveButton from "../BookNow/booknow";
import whatsAppIcon from "../../Assets/images/whatsapp.png";

const LandingPage = () => {
    const { loggedUser, userToken } = useContext(UserContext);
    const [adverts, setAdverts] = useState([]);
    const header = {
        token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
    }

    async function getAdverts() {
        await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/advert`, { headers: header })
            .then(({ data }) => {
                if (data.message === "success") {
                    setAdverts(data.adverts);
                }
            })
            .catch((error) => {
                // toast.error(error.response?.data.message)
            })
    }


    useEffect(() => {
        getAdverts()
    }, [])

    return (
        <div className="container">
            {/* Info Section with Slider */}
            <section className="home-slider p-3 rounded-2 mb-3 bg-light">
                <div className='greeterLargeMedia'>
                    <p className=' text-center fw-bold fs-3 ps-4'>{getGreeting()}</p>
                    <p className=' text-center fw-bold fs-3'>{loggedUser?.name?.toLowerCase().split(" ").map(word => word.charAt(0)?.toUpperCase() + word?.slice(1)).slice(0, 2).join(" ")}</p>
                    <h3 className="header-title-text m-0 d-flex justify-content-center  align-item-center gap-1">
                        <span className="main-color">SMART</span>
                        <span className="ps-1 ">TREND</span>
                    </h3>            </div>
                <Carousel indicators={false} controls={true} interval={2000} >
                    {adverts.map((ele) => (
                        <Carousel.Item key={ele._id} className='carousel-item'>
                            <div className="text-center carousel-div">
                                <img src={ele.image} alt="cover" className='w-100 h-100 carousel-img'
                                    style={{ objectFit: "cover", paddingBottom: "20px" }} />
                            </div>
                        </Carousel.Item>
                    ))}
                </Carousel>
            </section>

            <AboutUsSection />

            <ServicesSlider />

            <ReserveButton />

            {/* WhatsApp Float Button */}
            <a
                href="https://wa.me/+201066991090"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    left: '20px',
                    backgroundColor: '#25D366',
                    borderRadius: '50%',
                    width: '60px',
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
                    cursor: 'pointer',
                    zIndex: 1000,
                    transition: 'all 0.3s ease',
                    textDecoration: 'none'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(37, 211, 102, 0.6)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 211, 102, 0.4)';
                }}
            >
                <img src={whatsAppIcon} alt="WhatsApp" style={{ width: '60px', height: '60px' }} />
            </a>

            <a
                href="/#/login"
                rel="noopener noreferrer"
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    width: '60px',
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 12px black',
                    cursor: 'pointer',
                    zIndex: 1000,
                    transition: 'all 0.3s ease',
                    textDecoration: 'none',
                    border: '2px solid #0d203a'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.boxShadow = '0 6px 20px #0d203a';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 12px #0d203a';
                }}
            >
                <span style={{ fontSize: '45px', color: '#0d203a' }}>+</span>
            </a>

        </div>
    )
}

export default LandingPage;
